import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";

export const useCNPCImage = () => {
  const blockchain = useSelector((state) => state.blockchain);
  const [imgSrc, setImgSrc] = useState([]);

  const getCNPCImgSrc = useCallback(async (account) => {
    try {
      // バックエンドの向き先は config.json で切り替える(ビルドし直さずに済むように)
      // ローカルのエミュレーターなら "http://localhost:5001/cnpc-showcase-functions/us-central1/app"
      const configResponse = await fetch("/config/config.json", {
        cache: "no-cache", // サーバーの config.json を書き換えたら、すぐ効くように
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const CONFIG = await configResponse.json();
      const response = await fetch(
        `${CONFIG.BACKEND_URL}?address=${account}`,
        {
          headers: {
            mode: "no-cors",
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const result = await response.json();
      let imgSrcLists = JSON.parse(result.array.replaceAll(/'/g, ""));
      setImgSrc(imgSrcLists);
    } catch (error) {
      console.error("通信に失敗しました", error);
    }
  }, []);

  useEffect(() => {
    if (blockchain.account && blockchain.smartContract) {
      getCNPCImgSrc(blockchain.account);
    }
  }, [blockchain.account, blockchain.smartContract, getCNPCImgSrc]);

  return imgSrc;
};
